import moment from 'moment';
import { find } from 'lodash';

import template from './time.tpl.pug';

class TimeController {
    /* @ngInject */
    constructor($timeout) {
        this.$timeout = $timeout;

        this.units = [
            'year',
            'month',
            'week',
            'day',
            'hour',
            'minute',
            'second'
        ];
    }

    $onDestory() {
        this.clearTimer();
    }

    $onChanges(changeObject) {
        if (changeObject.timestamp) {
            this.updateDisplayedTime(changeObject.timestamp.currentValue);
        }
    }

    updateDisplayedTime(timestamp) {
        this.clearTimer();

        let now = moment();
        let date = moment(timestamp);
        
        let unit = this.getDisplayedUnit(this.units, date, now);

        let difference = date.diff(now, unit, true);
        let past = difference < 0;

        if (past) {
            difference = Math.abs(difference);
            [now, date] = [date, now];
        }

        let safeUnit = unit || this.units[this.units.length - 1];

        this.time = this.suffixify(this.format(moment.duration(date.diff(now)).as(safeUnit), safeUnit));
        this.onChange();

        if (unit) {
            let timeoutDuration = moment.duration(difference % 1, unit).asMilliseconds();
            this.timeoutId = this.$timeout(this.updateDisplayedTime.bind(this, timestamp), timeoutDuration);
        } else {
            this.onEnd();
        }
    }

    getDisplayedUnit(units, date, now) {
        // find the first unit which is displayable
        let unit = find(this.units, (unit) => date.diff(now, unit) !== 0);

        return unit && this.units.indexOf(unit) < this.units.indexOf(this.maxUnit)
            ? this.maxUnit
            : unit;
    }

    clearTimer() {
        if (this.timeoutId) {
            this.$timeout.cancel(this.timeoutId);
            this.timeoutId = null;
        }
    }

    format(quantity, unit) {
        quantity = Math.max(Math.ceil(quantity), 1);

        if (quantity === 1) {
            return `a ${unit}`;
        }

        return `${quantity} ${unit}s`;
    }

    suffixify(value, past) {
        return this.suffix
            ? past
                ? `${value} ago`
                : `in ${value}`
            : value;
    }
}

export default {
    selector: 'dbATime',
    template: template(),
    controller: TimeController,
    bindings: {
        timestamp: '<',
        suffix: '<',
        maxUnit: '@',
        onChange: '&',
        onEnd: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/time/time.cmpt.js